<seech-shared-dropdown [disabled]="disabled" [size]="size" [direction]="direction" [shape]="shape"
  [alignment]="alignment" [color]="color" [fontColor]="fontColor" [variant]="variant" [label]="label" 
  [icon]="icon" [id]="id" [hideBorder]="hideBorder" [showDropDownIcon]="showDropDownIcon">

  <ng-content select="[toggle]" ngProjectAs="[toggle]"> </ng-content>
  <ng-content> </ng-content>

</seech-shared-dropdown>